import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const story = [
  {
    emoji: "🌸",
    title: "FoundHer Belief Journey",
    subtitle: "Every Startup Begins With A Dream",
    text: "Meet Srishti.\n17 years old.\nFresh out of Junior College.\nOne notebook.\nHundreds of dreams.",
    bg: "from-pink-600 to-fuchsia-700",
  },

  {
    emoji: "🍭",
    title: "A Sweet Childhood",
    subtitle: "Dreams Begin Very Small",
    text: "Since childhood...\nShe loved marshmallows.\nChocolate candies.\nFruit candies.\nEvery candy had a story.",
    bg: "from-rose-500 to-pink-600",
  },

  {
    emoji: "🤔",
    title: "One Tiny Question",
    subtitle: "Curiosity Creates Entrepreneurs",
    text: '"Why can\'t one jar have many flavours?"\n\nThat question stayed with her for years.',
    bg: "from-purple-600 to-pink-700",
  },

  {
    emoji: "💡",
    title: "The Idea",
    subtitle: "Dream → Startup",
    text: "One jar.\nFour flavours.\nHealthy.\nColourful.\nFun.\n\nTrendyCandy was born.",
    bg: "from-yellow-500 to-orange-600",
  },

  {
    emoji: "😟",
    title: "Then Reality Arrived",
    subtitle: "Every Founder Feels This",
    text: '"Where do I begin?"\n\nBusiness?\nCustomers?\nMoney?\nPackaging?\nMarketing?\nEverything looked confusing.',
    bg: "from-rose-600 to-orange-500",
  },

  {
    emoji: "💜",
    title: "She Found FoundHer",
    subtitle: "Not Just Another App",
    text: "Someone introduced her to\nThink5Whys.\nPurpleDoor.\nFoundHer.\n\nFor the first time...\nher dream felt possible.",
    bg: "from-fuchsia-600 to-purple-700",
  },

  {
    emoji: "🧠",
    title: "Think5Whys",
    subtitle: "Purpose Before Profit",
    text: "Think5Whys didn't ask...\n'How will you sell?'\n\nIt asked...\n'Why do you want to build this?'",
    bg: "from-cyan-600 to-blue-700",
  },

  {
    emoji: "❤️",
    title: "Her Why",
    subtitle: "Purpose Found",
    text: '"Because candies create smiles.\n\nSmiles create memories.\n\nI want families to smile together."',
    achievement: "🧠 Achievement Unlocked • Purpose Found",
    bg: "from-red-500 to-pink-600",
  },

  {
    emoji: "👩",
    title: "FoundHer Profile",
    subtitle: "Meet The Founder",
    text: "She created her profile.\nNot just a business profile.\nA founder profile.\n\nHer journey officially began.",
    bg: "from-violet-600 to-fuchsia-700",
  },

  {
    emoji: "🚀",
    title: "The First Step",
    subtitle: "Every Big Company Started Here",
    text: "No investors.\nNo factory.\nNo employees.\n\nOnly belief.\nAnd the courage to begin.",
    bg: "from-indigo-600 to-purple-700",
  },
  {
    emoji: "🛠️",
    title: "Building TrendyCandy",
    subtitle: "Ideas Need Action",
    text: "Inside Venture...\n\nSrishti wrote her startup idea.\nProducts.\nCustomers.\nPricing.\nGoals.\n\nHer dream finally had a home.",
    bg: "from-orange-600 to-pink-600",
  },

  {
    emoji: "🎓",
    title: "Learning Before Earning",
    subtitle: "Academy",
    text: "She didn't know branding.\nShe didn't know packaging.\nShe didn't know pricing.\n\nSo she learned.\nOne lesson at a time.",
    bg: "from-blue-600 to-indigo-700",
  },

  {
    emoji: "🛍️",
    title: "My First Product",
    subtitle: "Marketplace",
    text: "Photos.\nDescription.\nPrice.\n\nOne click.\n\nTrendyCandy became visible to the world.",
    bg: "from-pink-500 to-rose-600",
  },

  {
    emoji: "🏡",
    title: "Start Local",
    subtitle: "FindItLocal",
    text: "Instead of chasing the whole country...\n\nShe started with her own neighbourhood.\nFriends.\nFamilies.\nNearby customers.",
    bg: "from-green-600 to-emerald-700",
  },

  {
    emoji: "📦",
    title: "The First Order",
    subtitle: "A Moment She Never Forgot",
    text: "📱 New Order.\n\nCash On Delivery.\n\n₹249.\n\nShe smiled.\nSomeone believed in TrendyCandy.",
    achievement: "🎉 Achievement Unlocked • First Customer",
    bg: "from-yellow-500 to-orange-500",
  },

  {
    emoji: "🫶",
    title: "VocalForLocal",
    subtitle: "Support Nearby Dreams",
    text: "People didn't buy just candy.\n\nThey supported a young founder.\n\nEvery local purchase helped another dream grow.",
    bg: "from-fuchsia-600 to-pink-700",
  },

  {
    emoji: "🥫",
    title: "NABORA",
    subtitle: "Digital Exhibition",
    text: "Srishti joined other young founders.\n\nTogether they created a digital exhibition.\n\nThree months later...\nThey met at a real exhibition.",
    bg: "from-cyan-600 to-teal-700",
  },

  {
    emoji: "🔥",
    title: "Happy Customers Returned",
    subtitle: "Streaks",
    text: "Buy.\nEnjoy.\nReturn.\nEarn rewards.\n\nCustomers loved collecting streaks.\nTrendyCandy kept growing.",
    bg: "from-orange-500 to-red-600",
  },

  {
    emoji: "🤝",
    title: "She Was Never Alone",
    subtitle: "Community",
    text: "Mentors guided.\nVolunteers helped.\nCustomers shared.\nFriends promoted.\n\nEvery success was shared together.",
    bg: "from-purple-600 to-indigo-700",
  },

  {
    emoji: "👑",
    title: "Now It's Your Turn",
    subtitle: "The Next Story Can Be Yours",
    text: "Srishti began with one dream.\n\nToday thousands of young women are waiting to discover theirs.\n\nYour journey starts with one small step.\n\nTake it today.",
    achievement: "💜 Welcome To FoundHer",
    bg: "from-fuchsia-600 via-pink-600 to-rose-700",
  },
];

export default function FoundHerJourney() {
  const navigate = useNavigate();

  const [current, setCurrent] = useState(0);
  const [listening, setListening] = useState(false);
  const [autoPlay, setAutoPlay] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);

  const page = story[current];

  const progress = useMemo(() => {
    return ((current + 1) / story.length) * 100;
  }, [current]);

  const next = () => {
    window.speechSynthesis.cancel();
    if (current < story.length - 1) {
      setCurrent((p) => p + 1);
    }
  };

  const previous = () => {
    window.speechSynthesis.cancel();
    if (current > 0) {
      setCurrent((p) => p - 1);
    }
  };

  useEffect(() => {
    if (!autoPlay || !listening || current >= story.length - 1) return;

    // Wait until speech completely finishes + small buffer
    if (!isSpeaking) {
      const timer = setTimeout(() => {
        if (current < story.length - 1) {
          setCurrent((p) => p + 1);
        }
      }, 2000); // Increased buffer
      return () => clearTimeout(timer);
    }
  }, [current, autoPlay, listening, isSpeaking]);

  useEffect(() => {
    if (!listening) {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
      return;
    }

    window.speechSynthesis.cancel();
    setIsSpeaking(true);

    const utterance = new SpeechSynthesisUtterance(
      `${page.title}. ${page.subtitle}. ${page.text.replace(/\n/g, ". ")}`,
    );

    utterance.rate = 0.95;
    utterance.pitch = 1.05;
    utterance.volume = 1;

    utterance.onend = () => setIsSpeaking(false);
    utterance.onerror = () => setIsSpeaking(false);

    window.speechSynthesis.speak(utterance);

    return () => {
      window.speechSynthesis.cancel();
    };
  }, [current, listening, page]);

  // Extra cleanup to prevent racing
  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, [current]);

  return (
    <div className="min-h-screen bg-[#09090f] text-white flex flex-col">
      <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-20 select-none">
        <div className="absolute top-20 left-10 text-5xl animate-bounce">
          💜
        </div>
        <div className="absolute top-44 right-8 text-4xl animate-pulse">💡</div>
        <div className="absolute bottom-32 left-8 text-5xl animate-bounce">
          🍭
        </div>
        <div className="absolute bottom-20 right-12 text-4xl animate-pulse">
          🚀
        </div>
        <div className="absolute top-1/4 left-1/4 text-5xl animate-ping">
          ✨
        </div>

        <div className="absolute top-2/3 right-1/3 text-4xl animate-bounce">
          🌸
        </div>

        <div className="absolute bottom-1/4 left-1/2 text-5xl animate-pulse">
          🫶
        </div>
      </div>
      <div className="bg-[#10111b] border-b border-fuchsia-900">
        <div className="px-4 py-4">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
            <div>
              <p className="text-pink-400 font-black text-xl">💜 FoundHer</p>
              <p className="text-xs text-gray-200">Belief Journey</p>
            </div>
            <div className="flex flex-wrap justify-center lg:justify-end gap-2">
              <button
                onClick={() => {
                  if (listening) {
                    window.speechSynthesis.cancel();
                  }
                  setListening(!listening);
                }}
                className={`w-fit px-3 py-2 rounded-xl text-xs font-bold ${
                  listening ? "bg-green-600" : "bg-gray-700"
                }`}
              >
                {listening ? "🔊 Listening" : "🎙 Listen"}
              </button>
              <button
                onClick={() => {
                  if (autoPlay) {
                    window.speechSynthesis.cancel();
                  }
                  setAutoPlay(!autoPlay);
                }}
                className={`w-fit px-3 py-2 rounded-xl text-xs font-bold ${
                  autoPlay ? "bg-blue-600" : "bg-gray-700"
                }`}
              >
                {autoPlay ? "⏸ Auto" : "▶ Auto"}
              </button>
              <button
                onClick={() => {
                  window.speechSynthesis.cancel();
                  navigate("/foundherhome");
                }}
                className="w-fit px-1 py-2 rounded-xl text-xs bg-fuchsia-600"
              >
                👋❤️ Bye →
              </button>
            </div>
          </div>

          <div className="mt-4">
            <div className="w-full h-2 rounded-full bg-gray-800 overflow-hidden">
              <div
                className="h-full rounded-full bg-gradient-to-r from-pink-500 to-fuchsia-500 transition-all duration-500"
                style={{
                  width: `${progress}%`,
                }}
              />
            </div>

            <div className="mt-2 flex justify-between text-xs text-gray-200">
              <span>
                Episode {current + 1} of {story.length}
              </span>
              <span>{Math.round(progress)}%</span>
            </div>
          </div>
        </div>
      </div>

      {/* STORY */}
      <div className="flex-1 flex items-center justify-center p-5">
        <div
          key={current}
          className={`w-full max-w-xl rounded-3xl bg-gradient-to-br ${page.bg} shadow-2xl p-8 animate-[pulse_0.35s]`}
        >
          <div className="text-center">
            <div className="text-8xl lg:text-9xl mb-8 animate-pulse">
              {page.emoji}
            </div>

            <h1 className="text-3xl lg:text-5xl font-black">{page.title}</h1>

            <p className="mt-4 text-pink-100 text-lg">{page.subtitle}</p>
            <div className="mt-10 text-lg leading-relaxed text-white">
              {page.text.split("\n").map((line, index) => (
                <p key={index} className={`${line === "" ? "h-4" : "mb-2"}`}>
                  {line}
                </p>
              ))}
              {page.achievement && (
                <div className="mt-8 rounded-2xl bg-white/15 backdrop-blur-lg border border-white/20 px-5 py-4">
                  <p className="text-lg font-bold">{page.achievement}</p>
                </div>
              )}
              {current === story.length - 1 && (
                <div className="mt-8 rounded-2xl bg-black/25 border border-white/10 p-5">
                  <p className="text-pink-300 text-xl font-black mb-4">
                    💜 Now It's Your Turn
                  </p>

                  <p className="text-gray-100 leading-8">
                    Srishti started with one dream.
                    <br />
                    <br />
                    Now...
                    <br />
                    What startup dream are <strong>YOU</strong> carrying in your
                    heart?
                    <br />
                    <br />
                    🍰 Bakery
                    <br />
                    👗 Fashion
                    <br />
                    🍫 Chocolates
                    <br />
                    💄 Beauty
                    <br />
                    💻 AI
                    <br />
                    🌱 Agriculture
                    <br />
                    🎨 Handmade
                    <br />
                    📚 Education
                    <br />
                    <br />
                    💜 Whatever your dream is...
                    <br />
                    FoundHer is ready to build it with you.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="bg-[#10111b] border-t border-fuchsia-900">
        <div className="p-4 flex justify-between">
          <button
            disabled={current === 0}
            onClick={previous}
            className="px-5 py-3 rounded-xl bg-gray-800 disabled:opacity-30"
          >
            ← Previous
          </button>

          {current < story.length - 1 ? (
            <button
              onClick={next}
              className="px-5 py-3 rounded-xl bg-pink-600 hover:bg-pink-500 font-bold"
            >
              Continue →
            </button>
          ) : (
            <button
              onClick={() => {
                window.speechSynthesis.cancel();
                navigate("/foundherhome");
              }}
              className="px-5 py-3 rounded-xl bg-green-600 hover:bg-green-500 font-bold"
            >
              💜 Enter FoundHer →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
